module.exports = __webpack_public_path__ + "static/img/toujiao9.10d840a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toujiao9.jpg
// module id = j0bO
// module chunks = 1